<template>
  <VInput
    v-if="!multiple && !Array.isArray(model)"
    ref="urlInput"
    v-model="inputValue"
    class="v-input--url"
    :error
    :optional
    placeholder="https://"
    :prop
    @blur="onBlur"
    @keydown.enter="urlInput?.input?.blur()"
  >
    <template v-if="!urlFocused && model" #value="{ disabled: isDisabled }">
      <VTag :closable="!disabled && !isDisabled" style="pointer-events: all" type="primary" @close="onClose">
        <a :href="model" style="pointer-events: auto" target="_blank"> {{ model }} </a>
      </VTag>
    </template>
  </VInput>
  <VSelect v-else v-model="model" allow-create :error filterable multiple no-dropdown :optional placeholder="https://" :prop>
    <template #value="{ disabled: isDisabled }">
      <div v-if="multiple && model" class="v-select__tags">
        <VTag v-for="value in model" :key="value" :closable="!disabled && !isDisabled" type="primary" @close="onClose(value)">
          <a :href="value" target="_blank" :title="value" v-text="value.length > 30 ? `${value.substring(0, 30)}..` : value" />
        </VTag>
      </div>
      <span v-else-if="!Array.isArray(model) && model">
        <a :href="model" target="_blank" :title="model" v-text="model.length > 30 ? `${model.substring(0, 30)}..` : model" />
      </span>
    </template>
  </VSelect>
</template>

<script setup lang="ts" generic="TModel extends string | string[] | null">
import { computed, ref, useTemplateRef, watch } from 'vue'

import VSelect from './Select/VSelect.vue'
import VInput from './VInput.vue'
import VTag from './VTag.vue'

defineProps<{
  disabled?: boolean
  error?: string | string[]
  multiple?: boolean
  optional?: boolean
  prop?: string
}>()

const model = defineModel<TModel | null>({ required: true })
const urlInput = useTemplateRef('urlInput')
const inputValue = ref<string | null>(null)

const urlFocused = computed((): boolean => !!urlInput.value?.focused)

watch(
  model,
  (value) => {
    if (Array.isArray(value)) {
      inputValue.value = null

      return
    }
    inputValue.value = value
  },
  { immediate: true },
)

function onClose(value?: string) {
  if (!Array.isArray(model.value)) {
    model.value = null

    return
  }

  model.value = model.value.filter((item) => value !== item) as TModel
}

function onBlur() {
  if (!Array.isArray(model.value)) {
    model.value = inputValue.value as TModel
  }
}
</script>

<style>
.v-input--url:not(.focused) input {
  color: transparent;
}
</style>
